import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { FormlySelectModule as FormlyCoreSelectModule } from '@ngx-formly/core/select';
import { FormlyFormFieldModule } from '../form-field/public_api';
import { FormlyFieldAutocomplete } from './autocomplete.type';

@NgModule({
    declarations: [FormlyFieldAutocomplete],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DropDownsModule,

        FormlyFormFieldModule,
        FormlyCoreSelectModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'kendo-autocomplete',
                    component: FormlyFieldAutocomplete,
                    wrappers: ['simple-form-field'],
                    //wrappers: ['kendo-form-field'],
                }
            ],
        }),
    ],
})
export class FormlyAutocompleteModule { }
